import React from 'react';
import { BookOpenIcon, CheckCircleIcon } from 'lucide-react';
export const CourseModules = () => {
  return <section className="mb-10" data-id="element-103">
      <h2 className="text-xl font-bold text-blue-800 mb-6 flex items-center" data-id="element-104">
        <BookOpenIcon className="w-6 h-6 mr-2 text-blue-600" data-id="element-105" />
        Met de cursus Liefdevol Communiceren ontdek je hoe je je hond écht kunt
        begrijpen, zodat jullie een ongekend sterke band van vertrouwen op
        kunnen bouwen
      </h2>

      <p className="mb-6 leading-relaxed" data-id="element-106">
        <a href="https://stresslessdogs.nl/lc-fb-adv2" className="text-blue-600 hover:underline cursor-pointer" target="_blank" rel="noopener noreferrer" data-id="element-107">
          De cursus 'Liefdevol Communiceren'
        </a>{' '}
        bestaat uit 6 modules die je stap voor stap meenemen in de hondentaal:
      </p>

      <div className="space-y-4 mb-8" data-id="element-108">
        <div className="border border-blue-200 rounded-lg overflow-hidden bg-white" data-id="element-109">
          <div className="bg-blue-50 p-4 flex items-start" data-id="element-110">
            <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3 flex-shrink-0" data-id="element-111">
              1
            </div>
            <div data-id="element-112">
              <h4 className="font-bold text-blue-800" data-id="element-113">
                Module 1: Tools voor het dagelijks leven
              </h4>
            </div>
          </div>
          <div className="p-4" data-id="element-114">
            <p className="text-sm text-gray-700" data-id="element-115">
              De basis van hondencommunicatie. Je leert de signalen herkennen
              die je hond elke dag gebruikt, en hoe je zelf deze signalen kunt
              inzetten.
            </p>
          </div>
        </div>

        <div className="border border-blue-200 rounded-lg overflow-hidden bg-white" data-id="element-116">
          <div className="bg-blue-50 p-4 flex items-start" data-id="element-117">
            <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3 flex-shrink-0" data-id="element-118">
              2
            </div>
            <div data-id="element-119">
              <h4 className="font-bold text-blue-800" data-id="element-120">
                Module 2: Sociale Vaardigheden — Omgangsregels
              </h4>
            </div>
          </div>
          <div className="p-4" data-id="element-121">
            <p className="text-sm text-gray-700" data-id="element-122">
              Hoe honden onderling omgaan en wat dit betekent voor jouw
              interactie met je hond. Leer de 'etiquette' van de hondenwereld.
            </p>
          </div>
        </div>

        <div className="border border-blue-200 rounded-lg overflow-hidden bg-white" data-id="element-123">
          <div className="bg-blue-50 p-4 flex items-start" data-id="element-124">
            <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3 flex-shrink-0" data-id="element-125">
              3
            </div>
            <div data-id="element-126">
              <h4 className="font-bold text-blue-800" data-id="element-127">
                Module 3: Sociale Vaardigheden — Tafelmanieren
              </h4>
            </div>
          </div>
          <div className="p-4" data-id="element-128">
            <p className="text-sm text-gray-700" data-id="element-129">
              Praktische communicatie rondom eten, rust en grenzen stellen.
              Zonder confrontatie, met respect.
            </p>
          </div>
        </div>

        <div className="border border-blue-200 rounded-lg overflow-hidden bg-white" data-id="element-130">
          <div className="bg-blue-50 p-4 flex items-start" data-id="element-131">
            <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3 flex-shrink-0" data-id="element-132">
              4
            </div>
            <div data-id="element-133">
              <h4 className="font-bold text-blue-800" data-id="element-134">
                Module 4: Sociale Vaardigheden — Jouw reactie
              </h4>
            </div>
          </div>
          <div className="p-4" data-id="element-135">
            <p className="text-sm text-gray-700" data-id="element-136">
              Hoe je reageert op ongewenst gedrag, op een manier die je hond
              begrijpt én respecteert.
            </p>
          </div>
        </div>

        <div className="border border-blue-200 rounded-lg overflow-hidden bg-white" data-id="element-137">
          <div className="bg-blue-50 p-4 flex items-start" data-id="element-138">
            <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3 flex-shrink-0" data-id="element-139">
              5
            </div>
            <div data-id="element-140">
              <h4 className="font-bold text-blue-800" data-id="element-141">
                Module 5: Het Attentie Signaal
              </h4>
            </div>
          </div>
          <div className="p-4" data-id="element-142">
            <p className="text-sm text-gray-700" data-id="element-143">
              Leer hoe je de aandacht van je hond krijgt zonder te roepen,
              commanderen of te corrigeren.
            </p>
          </div>
        </div>

        <div className="border border-blue-200 rounded-lg overflow-hidden bg-white" data-id="element-144">
          <div className="bg-blue-50 p-4 flex items-start" data-id="element-145">
            <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3 flex-shrink-0" data-id="element-146">
              6
            </div>
            <div data-id="element-147">
              <h4 className="font-bold text-blue-800" data-id="element-148">
                Module 6: Het Handgebaar
              </h4>
            </div>
          </div>
          <div className="p-4" data-id="element-149">
            <p className="text-sm text-gray-700" data-id="element-150">
              Communiceer met je hond zonder woorden. Een krachtige techniek
              voor rustige samenwerking.
            </p>
          </div>
        </div>
      </div>

      <p className="mb-6 leading-relaxed" data-id="element-151">
        Elke module bevat video's met uitleg, praktijkbeelden en voorbeelden
        zodat je precies ziet hoe het werkt. Plus printbare stappenplannen die
        je kunt gebruiken tijdens het oefenen.
      </p>

      <a href="https://stresslessdogs.nl/lc-fb-adv2" className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg transition duration-200 block text-center mb-8" target="_blank" rel="noopener noreferrer" data-id="element-152">
        Bekijk de cursus
      </a>

      <div className="bg-green-50 p-6 rounded-lg border border-green-200 mb-8" data-id="element-153">
        <h3 className="text-lg font-bold text-green-800 mb-4" data-id="element-154">
          Inclusief 3 bonussen:
        </h3>
        <ul className="space-y-3" data-id="element-155">
          <li className="flex items-start" data-id="element-156">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-157" />
            <span data-id="element-158">
              <strong data-id="element-159">Bonus Masterclass "Honden Geschiedenis"</strong> — Begrijp
              waar het gedrag van je hond vandaan komt en waarom communicatie zo
              essentieel is.
            </span>
          </li>
          <li className="flex items-start" data-id="element-160">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-161" />
            <span data-id="element-162">
              <strong data-id="element-163">8 printbare stappenplannen</strong> — Voor elke
              communicatievaardigheid een handig overzicht dat je kunt
              uitprinten.
            </span>
          </li>
          <li className="flex items-start" data-id="element-164">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-165" />
            <span data-id="element-166">
              <strong data-id="element-167">Levenslange toegang</strong> — Je kunt de cursus op je
              eigen tempo volgen en zo vaak terugkijken als je wilt.
            </span>
          </li>
        </ul>
      </div>

      <div className="w-full mb-6" data-id="element-168">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4q5cC71mhLz2oJ2dhhpDRD/Scherm_afbeelding_2025-08-15_om_15.46.41-min.png" alt="Vrouw wandelt ontspannen met haar hond op een bospad" className="w-full h-auto rounded-lg shadow-md" data-id="element-169" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-170">
          Een stressvrij leven voor je hond. En voor jou.
        </p>
      </div>
    </section>;
};